export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10405.5f0fea69.jpg";